import { IBriefEducationalScenario } from "../../briefs/types/IBriefEducationalScenario";
import { IClassroomResource } from "../../classrooms";
import { EntityTypes } from "../../EntityTypes";
import { IProfessionalSituationEducationalScenario } from "../../professional-situations";
import { IHydraResource, ITimestampable } from "../../types";

export enum EducationalBriefStatus {
    DISPLAY = "displayed",
    HIDDEN = "hidden",
}
export interface EducationalBriefs extends IHydraResource {
    brief: IBriefEducationalScenario;
    rank: number;
    status: EducationalBriefStatus;
    uuid: string;
}

export interface EducationalClassroom extends IClassroomResource {
    trainers: string[];
}

export interface IEducationalScenarioItem extends IHydraResource, ITimestampable {
    "@type": EntityTypes.EDUCATIONAL_SCENARIO_ITEM;
    classroom: EducationalClassroom;
    educationalBriefs: EducationalBriefs[];
    professionalSituation: IProfessionalSituationEducationalScenario;
    endDate: string;
    startDate: string;
}
